// extracted by mini-css-extract-plugin
export default {"container":"quizzes_container__wVn+p","newQuizzesContainer":"quizzes_newQuizzesContainer__eEchm","textDraw":"quizzes_textDraw__0KXzl"};